/* eslint-disable no-loop-func */
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import assign from 'lodash/assign';
import formula from 'excel-formula';

import Datasheet from 'react-datasheet';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import DataContext from '../../../Contexts/DataContext';
import ChangeDetails from './changeDetails';
import { numberToColumn, numberWithCommas } from '../../../Helpers/utils';

import './change.scss';
import { currencyFormatter, getRowId } from '../../../Helpers/aggrid';
import { AgGridReact } from 'ag-grid-react';

import { useAuth } from '../../../Contexts/AuthContext';

export default function Change(props) {
  const context = useContext(DataContext);

  const gridPreviewRef = useRef();

  const [previewGridData, setPreviewGridData] = useState({});
  const [changeData, setChangeData] = useState();


  let activeProject = useMemo(() => context.activeProject, [context.activeProject]);

  const auth = useAuth();

  let {
    addChange,
    cancelChange,
    changeToEdit,
    editChange,
    isEditing,
    onCalculatingStart,
    onCalculatingFailed,
    toggleEditing,
  } = props;


  const {
    activeUser
  } = auth

  // Data input by user to initialize the bridge entry.
  // Specifies account(s) to be bridge, reference account(s), and account taxonomy data
  // let changeSetupData = {
  //   'AccountsToBeBridged': [
  //   ],
  //   'BridgeAdjustment': [
  //   ],
  //   'reference_accounts': [
  //   ],
  // };

  /**
   * Accepts an active project object and a changeSetupDate object 
   * @param {String} activeProject - Project currently being bridged
   * @param {Object} projects - Objects currently existing in the application
   * @param {Object} changeSetupDate - Data entered by user to initialize a changed based on reference account data
   */
  // const buildSpreadsheet = (changeSetupData) => {
  //   console.log("change setup data", changeSetupData);
  //   let {
  //     activeProject,
  //     projects
  //   } = this.context;

  //   let changeData = cloneDeep(changeSetupData);

  //   console.log("changeData", changeData);

  //   if (changeData) {
  //     changeData.reference_accounts.forEach(referenceAccount => {
  //       changeData.BridgeAdjustment.forEach(bridgedAdjustment => {
  //         if (referenceAccount['Account ID'] === bridgedAdjustment['Account ID']) {
  //           Object.keys(referenceAccount.dates).forEach(key => {
  //             referenceAccount.dates[key] = (Number(referenceAccount.dates[key].replaceAll(',', '')) + Number(bridgedAdjustment.dates[key])).toLocaleString()
  //           })
  //         }
  //       })
  //     })
  //   }


  //   let columns = [
  //     'Title',
  //     'Secondary Title',
  //   ];
  //   let entries = [];
  //   let grid = {
  //     '0': { key: '0', value: '', expr: '', className: '' },
  //   };

  //   if (activeProject) {
  //     let dates = projects[activeProject].projectData.dates;
  //     dates.forEach((date) => {
  //       columns.push(date);
  //     });

  //     // Build the Grid
  //     let x = 0; // This variable will be incremented for each "row" that is created, based on Reference Account(s), Bridged Account(s), and Adjustment Bridge(s)

  //     // Run first iteration of grid building; this will output the "label" row, containing project dates
  //     let rowCells = this._formatCell(x, '', columns);

  //     // Add columns as first row for labeling
  //     entries.push(columns);
  //     ++x;

  //     grid = Object.assign({}, grid, rowCells);
  //     // Build cells for Reference Accounts

  //     let referenceAccountLength = Object.keys(changeData.reference_accounts).length;

  //     if (referenceAccountLength) {
  //       // Create a "row" that has data attributes mirrioring an actual entry
  //       let labelData = {
  //         'Title': 'Reference Account(s)',
  //         'Secondary Title': 'Reference Account(s)'
  //       };
  //       entries.push(labelData);
  //       let titleRow = this._formatCell(x, labelData, columns,);
  //       grid = Object.assign({}, grid, titleRow);
  //       ++x;
  //     }

  //     for (let i = 0; i < referenceAccountLength; i++) {
  //       let referenceAccount = changeData.reference_accounts[i];

  //       entries.push(changeData.reference_accounts[i]);
  //       referenceAccount['Secondary Title'] = referenceAccount['Account Name'];
  //       rowCells = this._formatCell(x, referenceAccount, columns);
  //       grid = Object.assign({}, grid, rowCells);
  //       ++x;

  //       //Add a spacer row at the end of reference accounts
  //       if (i === (referenceAccountLength - 1)) {
  //         // Pushes an empty row with no data for spacing
  //         entries.push({});
  //         rowCells = this._formatCell(x, '', columns, true);
  //         grid = Object.assign({}, grid, rowCells);
  //         ++x;
  //       }
  //     }

  //     let accountsToBeBridgedLength = Object.keys(changeData.AccountsToBeBridged).length;
  //     for (let i = 0; i < accountsToBeBridgedLength; i++) {
  //       let accountToBeBridged = changeData.AccountsToBeBridged[i];
  //       let bridgeAdjustment = changeData.BridgeAdjustment

  //       let labelData = {
  //         'Title': 'Account',
  //         'Secondary Title': accountToBeBridged['Account Name']
  //       }
  //       entries.push(labelData);
  //       rowCells = this._formatCell(x, labelData, columns);
  //       grid = Object.assign({}, grid, rowCells);
  //       ++x;

  //       entries.push(accountToBeBridged);
  //       accountToBeBridged['Secondary Title'] = 'Base';
  //       rowCells = this._formatCell(x, accountToBeBridged, columns);
  //       grid = Object.assign({}, grid, rowCells);
  //       ++x;

  //       //Loop through changes and display all changes entered in for this particular account in the BridgeAdjustment array of changeData
  //       let adjustedTotals = {};
  //       dates.forEach((date) => {
  //         adjustedTotals[date] = parseInt(accountToBeBridged.dates[date]?.replace(',', ''));
  //       });
  //       bridgeAdjustment.forEach((adjustment) => {
  //         if (adjustment['Account ID'] === accountToBeBridged['Account ID']) {
  //           // Sum adjustments for final total of account value
  //           Object.keys(adjustment.dates).forEach((date) => {
  //             if (!adjustment.ref_account_formula) {
  //               adjustedTotals[date] = parseInt(adjustedTotals[date]) + parseInt(adjustment.dates[date]);
  //             } else {
  //               let changeAmount = formula.toJavaScript(adjustment.ref_account_formula);
  //               //Loop through each reference account and replace the corresponding row label with the reference accounts value for the given date
  //               changeData.reference_accounts.forEach((refAccount, i) => {
  //                 let rowLabel = numberToColumn(i + 2);
  //                 let initialRefAccountValue = typeof(refAccount.dates[date]) === 'string' ?  refAccount.dates[date].replace(',', '') : refAccount.dates[date];
  //                 changeAmount = changeAmount.replaceAll(rowLabel, initialRefAccountValue);
  //               })
                
  //               changeAmount = mathjs.evaluate(changeAmount);
  //               adjustment.dates[date] = changeAmount
  //               adjustedTotals[date] = parseInt(adjustedTotals[date]) + changeAmount;
  //             }
  //           });
  //           adjustment['Secondary Title'] = adjustment['Change Label'];
  //           entries.push(adjustment);
  //           rowCells = this._formatCell(x, adjustment, columns);
  //           grid = Object.assign({}, grid, rowCells);
  //           ++x;
  //         }
  //       });

  //       let adjustedTotalRow = {
  //         dates: { ...adjustedTotals },
  //         'Secondary Title': 'New Value'
  //       }

  //       entries.push(adjustedTotalRow);
  //       rowCells = this._formatCell(x, adjustedTotalRow, columns);
  //       grid = Object.assign({}, grid, rowCells);
  //       ++x;

  //       //Add a spacer row at the end of reference accounts
  //       if (i === (accountsToBeBridgedLength - 1)) {
  //         // Pushes an empty row with no data for spacing
  //         // entries.push({});
  //         rowCells = this._formatCell(x, '', columns, true);
  //         grid = Object.assign({}, grid, rowCells);
  //         ++x;
  //       }
  //     }
  //   }
  //   this.setState({
  //     columns: columns,
  //     entries: entries,
  //     gridData: grid
  //   });
  // }

  const onCellsChanged = (changes) => {
    const state = assign({}, this.state)
    changes.forEach(({ cell, value }) => {
      this.cellUpdate(state, cell, value)
    })
    this.setState(state)
  }

  /**
   * This function details how a change should be calculated to show a new value for an account
   * 
   * @param {Object} change The specific details outlining how the change should be calculated and displayed in the bridge.
   * @returns {boolean} True if the change was successful, false otherwise
   */
  const handlePreviewChange = async (change) => {

    // buildPreview(change);
    
    if(changeToEdit){
      const success = await editChange(change);
      return success;
    }
    else{
      const success = await addChange(change);
      if (success) {
        toggleEditing();
      }
      return success;
    }

    /*----------------------------------------------------------------------*/
    // This logic is for change screen preview purposes only

    // let change = {
    //   dates: {}
    // };

    // const accountsArr = changeData.selected_accounts;
    // // Loop over each account selected in the change
    // accountsArr.forEach(accountToChange => {
    //   if (changeSetupData.AccountsToBeBridged.length > 0) {
    //     changeSetupData.AccountsToBeBridged.forEach((account) => {
    //       if (accountToChange['Account ID'] === account['Account ID']) {
    //         skipAccount = true;
    //       }
    //     })
    //   }

    //   if (changeSetupData.reference_accounts.length > 0 && changeData.referenceAccount.length > 0) {
    //     changeSetupData.reference_accounts.forEach((account) => {
    //       if (changeData.referenceAccount.filter(ref => ref.glKey === `${account['Department ID']}-${account['Account ID']}`).length > 0) {
    //         skipRefAccount = true;
    //       }
    //     })
    //   }

    //   // Here we are building the date values for a change
    //   let changeAccount = {
    //     dates: {}
    //   };
    //   // Get the changeAccount values for each month listed
    //   dates.forEach((date) => {
    //     changeAccount.dates[date] = accountToChange[date];
    //   });

    //   // Build the object detailing the changeAccount 
    //   changeAccount = {
    //     ...changeAccount,
    //     'Account ID': accountToChange['Account ID'],
    //     'Account Name': accountToChange['Account Name'],
    //     'Acct Type': accountToChange['Acct Type'],
    //     'Department ID': accountToChange['Department ID'],
    //     'Department Name': accountToChange['Department Name'],
    //     'Driver': accountToChange['Driver'],
    //     'Entity': accountToChange['Entity'],
    //     'Fixed or Variable': accountToChange['Fixed or Variable'],
    //     'Parent Account': accountToChange['Parent Account'],
    //     'firstLetter': accountToChange['firstLetter'],
    //     'change_label': changeData.change_label,
    //     'driven_accountsChanges': {},
    //   }

    //   // if this account does not already have changes, add it to the AccountsToBeBridged object for display in the change preview component
    //   if (!skipAccount) {
    //     changeSetupData.AccountsToBeBridged.push(changeAccount);
    //   }

    //   //If this is a reference account change, and the reference account doesn't already exist in the ReferenceAccount object, then add it to the reference account object
    //   if (changeData.function_operator === "referenceAccount" && !skipRefAccount) {
    //     changeData.referenceAccount.forEach(referenceAccount => {
    //       let refAccount = {
    //         dates: {}
    //       };
  
    //       dates.forEach((date) => {
    //         refAccount.dates[date] = referenceAccount[date];
    //       });
  
    //       refAccount = {
    //         ...refAccount,
    //         'Account ID': referenceAccount['Account ID'],
    //         'Account Name': referenceAccount['Account Name'],
    //         'Acct Type': referenceAccount['Acct Type'],
    //         'Department ID': referenceAccount['Department ID'],
    //         'Department Name': referenceAccount['Department Name'],
    //         'Driver': referenceAccount['Driver'],
    //         'Entity': referenceAccount['Entity'],
    //         'Fixed or Variable': referenceAccount['Fixed or Variable'],
    //         'Parent Account': referenceAccount['Parent Account'],
    //         'firstLetter': referenceAccount['firstLetter'],
    //       }
    //       changeSetupData.reference_accounts.push(refAccount);

    //     })
    //   }

    //   const operator_value = changeData.function_operator === "percentage" ? changeData.operator_value / 100 : changeData.operator_value;

    //   // Loop through each date, calculate the change, and apply the new value
    //   changeData.date_range.forEach((date) => {
    //     let changeAmount;
    //     let initialValue = typeof(changeAccount.dates[date]) === 'string' ? parseInt(changeAccount.dates[date]?.replace(',', '')) : changeAccount.dates[date];
    //     if (changeData.function_operator === "percentage") {
    //       changeAmount = initialValue * operator_value;
    //     }
    //     else if (changeData.function_operator === "absoluteValue") {
    //       changeAmount = operator_value;
    //     }
    //     else if (changeData.function_operator === "referenceAccount") {
    //       //NOTE: (Alex) I need to be able to insert the initial value and reference account calculations as variables in a custom formula
    //       changeAmount = formula.toJavaScript(changeData.ref_account_formula);
    //       changeAmount = changeAmount.replace('A', initialValue);

    //       //Loop through each reference account and replace the corresponding row label with the reference accounts value for the given date
    //       changeSetupData.reference_accounts.forEach((refAccount, i) => {
    //         let rowLabel = numberToColumn(i + 2);
    //         let initialRefAccountValue = typeof(refAccount.dates[date]) === 'string' ? refAccount.dates[date].replace(',', ''): refAccount.dates[date];
    //         changeAmount = changeAmount.replaceAll(rowLabel, initialRefAccountValue);
    //       })

    //       changeAmount = mathjs.evaluate(changeAmount);

    //       // console.log('post-resolution', changeAmount);
    //       // SUM(A+(B*0.02))
    //       // IF(B*0.02>270,300,B*0.02)

    //     }
    //     else { console.error("Bad function_operator"); }

    //     change.dates[date] = parseInt(`${changeAmount}`);
    //   });

    //   console.log(drivers);

    //   // If this is a Stat Driver, make ratio adjustments to all accounts in the same department driven by this account
    //   const is_stat_driver = drivers.includes(changeAccount['Account Name']); // Is this account a stat driver?
    //   let driven_accounts = []; // Array to hold accounts driven by our driver account
    //   if (is_stat_driver) {
    //     console.log("is_stat_driver", is_stat_driver);
    //     const departmentId = changeAccount['Department ID'];
    //     const driver = changeAccount['Account Name'];
    //     changeAccount.is_stat_driver = true;
    //     changeAccount.change = change;

    //     Object.entries(accounts).forEach((account) => {
    //       // If the account is in the same department, and is driven by this stat account, add it to the list of accounts to be changed
    //       if (account[1]['Department ID'] == departmentId && (account[1]['Driver'] !== undefined && account[1]['Driver'] == driver)) {
    //         driven_accounts.push(account[1]);
    //       }
    //     });
    //     console.log("driven accounts", driven_accounts);
    //     changeAccount.driven_accounts = driven_accounts;
    //   }

    //   change = {
    //     ...change,
    //     'Account ID': accountToChange['Account ID'],
    //     'Change Label': changeData.change_label,
    //     ref_account_formula: changeData.ref_account_formula,
    //     driven_accounts: driven_accounts,
    //     is_stat_driver: is_stat_driver,
    //   }
    //   changeSetupData.BridgeAdjustment.push(change);
    // })



    // // this.buildSpreadsheet(changeSetupData);
    // this.gridPreviewRef?.current?.api?.setRowData([])
    // this.setState({
    //   changeSetupData: changeSetupData,
    //   isEditing: true,
    // });
  }

  const buildPreview = (change) => {

  }

  const handleAddChange = (change) => {
    addChange(change);
  }

  const onGridReady = (params) => {
  }


  const onEntitiesChange = async (params) => {
    // Ensure params is always an array
    const paramsArray = Array.isArray(params) ? params : [params];
  
    // Extract entity_id and entity_name from each param
    const entitiesArray = paramsArray.map((param) => ({
      entity_id: param.entity_id,
      entity_name: param.entity_name,
    }));
  
    // Call the function with the entitiesArray
    await context.setActiveProjectDepartmentsAttribute(
      activeProjectInfo.id,
      entitiesArray,
      activeUser.accessToken
    );
  };
  


  const onDepartmentSelected = async (params) => {
    // Only fetch if the accounts list has never been loaded (null/undefined).
    // Checking for null/undefined (not .length) correctly handles projects that
    // genuinely have zero accounts — those return an empty array which should not
    // trigger a refetch on every department-selection change.
    if (activeProjectAttributes?.accountsMetadata == null) {
      await context.setActiveProjectAccountsAttribute(
        activeProjectInfo.id,
        activeUser.accessToken
      );
    }
  }

  // let columnDefs = [];

  // if (columns) {
  //   columnDefs = columns.map(column => ({
  //     field: column,
  //     resizable: true,
  //     maxWidth: 100,
  //     cellStyle: {
  //       padding: 0
  //     },
  //     valueFormatter: currencyFormatter
  //   })).slice(2)
  // }

  // const allColumnDefs = [
  //   {
  //     field: 'letterLabel',
  //     headerName: '',
  //     maxWidth: 50
  //   },
  //   {
  //     field: "Secondary Title",
  //     headerName: '',
  //     maxWidth: 150
  //   },
  //   ...columnDefs
  // ]

  // let rows = entries ? [...entries] : [];
  // rows = rows.map((entry, i) => ({
  //   ...entry?.dates,
  //   letterLabel: numberToColumn(i),
  //   'Secondary Title': entry['Secondary Title']
  // }))
  // rows.shift()

  // const defaultColDef = () => ({
  //   filter: true,
  //   resizeable: true,
  //   sortable: true,
  // });




  let activeProjectInfo = useMemo(() => context.activeProjectInfo, [context.activeProjectInfo]);
  let activeProjectAttributes = useMemo(() => context.activeProjectAttributes, [context.activeProjectAttributes])
  
  const activeProjectEntitiesCheck = useCallback(async () => {
    if (!activeProjectAttributes || activeProjectAttributes.entities.length === 0) {
      await context.setActiveProjectEntitiesAttribute(activeProjectInfo.id, activeUser.accessToken);
    }
  }, []);
  
  useEffect(() => {
    if (activeProjectInfo) {
      activeProjectEntitiesCheck()
    }
  }, [activeProjectInfo])


  return (
    <Grid container item xs={12}>
      <Grid item xs={3}>
        <Button
          color={"error"}
          onClick={() => toggleEditing(false)}
          startIcon={<ArrowBackIosIcon />}
          sx={{
            display: 'flex',
            mb: '1rem',
            ml: '1rem',
          }}
          variant="text"
        >
          Project Home
        </Button>
      </Grid>
      <Grid item container xs={12}>
        <ChangeDetails
          cancelChange={cancelChange}
          changeToEdit={changeToEdit}
          isEditing={isEditing}
          previewChange={handlePreviewChange}
          toggleEditing={() => toggleEditing(!isEditing)}
          onEntitiesChange={onEntitiesChange}
          onDepartmentSelected={(params) => onDepartmentSelected(params)}
          onCalculatingStart={onCalculatingStart}
          onCalculatingFailed={onCalculatingFailed}
        />
      </Grid>
      {/* {gridData && <>
        <Grid item xs={12}>
          <div className="ag-theme-alpine preview-changes-ag-grid" style={{ textAlign: 'left' }}>
            <AgGridReact
              animateRows={true} // Optional - set to 'true' to have rows animate when sorted
              columnDefs={allColumnDefs} // Column Defs for Columns
              defaultColDef={defaultColDef} // Default Column Properties
              getRowId={getRowId} // Manually assign Row IDs
              onGridReady={this.onGridReady}
              ref={this.gridPreviewRef} // Ref for accessing Grid's API
              rowData={rows} // Row Data for Rows
              domLayout='autoHeight'
              suppressSizeToFit={true}
            />
          </div>
        </Grid>
        
      </>
      } */}
      {/* <Grid
        item
        container
        xs={12}
        sx={{
          alignItems: 'flex-start',
          marginTop: '20px',
          marginLeft: '20px',
        }}
      >
        <Button
          color={"primary"}
          variant="contained"
          onClick={handleAddChange}
        >
          Submit Change
        </Button>
      </Grid> */}
    </Grid>
  );
}